// Helper function to remove empty values
const cleanObject = (obj) => {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, value]) => value != null && value !== '')
            .map(([key, value]) => [
                key,
                value && typeof value === 'object' ? cleanObject(value) : value
            ])
    );
};

export default cleanObject;